import React from 'react';
import { Link } from 'gatsby';
import style from './button.module.css';

export default function Button({ title, type, link, onClick, invisible}) {
  const className = t => {
    let result;
    switch (t) {
      case 'primary':
        result = ['button-1', style.button, style.buttonPrimary];
        if (invisible) result.push('invisible');
        return result.join(' ');
      case 'secondary':
        result = ['button-1', style.button, style.buttonSecondary];
        if (invisible) result.push('invisible');
        return result.join(' ');
      case 'tertiary':
        result = ['button-1', style.button, style.buttonTertiary];
        if (invisible) result.push('invisible');
        return result.join(' ');
      case 'pink': 
        result= ['button-1', style.button, style.buttonPink];
        if (invisible) result.push('invisible');
        return result.join(' ');
      case 'pink-inactive': 
        result= ['button-1', style.button, style.buttonPinkInactive];
        if (invisible) result.push('invisible');
        return result.join(' ');
      case 'gradient': 
        result= ['button-1', style.button, style.buttonGradient];
        if (invisible) result.push('invisible');
        return result.join(' ');
      case 'purple':
        result= ['button-1', style.button, style.buttonPurple];
        if (invisible) result.push('invisible');
        return result.join(' ');
      case 'purple-inactive':
        result= ['button-1', style.button, style.buttonPurpleInactive];
        if (invisible) result.push('invisible');
        return result.join(' ');
      case 'outlines':
        result = ['button-1', style.button, style.buttonOutlines];
        if (invisible) result.push('invisible');
        return result.join(' ');
      default:
        if (invisible) {
          return ['invisible'].join(' ');
        } else {
          return null;
        }
    }
  };

  const buttonLink = href => href || '/';

  if (link) {
    if (link.indexOf('http') > -1) {
      return (
        <a href={buttonLink(link)} className={className(type)}>
          {title}
        </a>
      );
    }
    return (
      <Link to={buttonLink(link)} className={className(type)} activeStyle={{color: "var(--third-color)", fontWeight: "bold"}}>
        {title}
      </Link>
    );
  }

  return (
    <a onClick={onClick} className={className(type)}>
      {title}
    </a>
  );
}
